import type { ConfluenceHomeBanner } from '@post-office/placement-common/pipes';
import {
	createClientPipeline,
	createServerPipeline,
} from '@post-office/placement-common/utils/create-pipeline';

import { type MessageTemplateContext } from '../../..';

export type HydrationResult = Record<string, never>;

type Pipe = ConfluenceHomeBanner<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

export const { createRender, createValidate } = createClientPipeline<Pipe>();
export const { createHydrate, createHydrateExample, createTransformMetadata } =
	createServerPipeline<Pipe>();
